import componentShell from "./shell"
import SignsExample from "@/client/components/signs/example"

export default componentShell(SignsExample)
